/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Typescript_Output_LabelInputs */

const en_typescript_output_label = /** @type {(inputs: Typescript_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TypeScript Output`)
};

const ko_typescript_output_label = /** @type {(inputs: Typescript_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TypeScript 출력`)
};

const ja_typescript_output_label = /** @type {(inputs: Typescript_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TypeScript出力`)
};

/**
* | output |
* | --- |
* | "TypeScript Output" |
*
* @param {Typescript_Output_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const typescript_output_label = /** @type {((inputs?: Typescript_Output_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Typescript_Output_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_typescript_output_label(inputs)
	if (locale === "ko") return ko_typescript_output_label(inputs)
	return ja_typescript_output_label(inputs)
});